import { APP_COLOR, FONT_FAMILY } from "../theme";

export const notFoundPageStyles = {
  notFoundPageContainer: {
    minHeight: "calc(100vh - 200px)",
    fontFamily: FONT_FAMILY,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "40px 20px",
    textAlign: "center",
    boxSizing: "border-box",
  } as const,
  goToMainPageButton: {
    backgroundColor: APP_COLOR,
    color: "#041017",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    fontSize: 15,
    borderRadius: "10px",
    padding: "10px 24px",
    boxShadow: "0 4px 14px rgba(39, 182, 203, 0.25)",
    "&:hover": {
      backgroundColor: "#41d3e8",
      boxShadow: "0 6px 20px rgba(39, 182, 203, 0.35)",
    },
  } as const,
  goToMainPageButtonLink: {
    marginTop: 24,
    textDecoration: "none",
    display: "inline-block",
  } as const,
  loadingBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  } as const,
  divStyle: {
    height: "200px",
  } as const,
};
